export default __webpack_public_path__ + "static/media/house.94887ada.png";